import React, {useEffect, useState} from "react";
import {Box, MenuItem, FormControl, useMediaQuery, InputAdornment} from "@mui/material";
import { Loader } from "@googlemaps/js-api-loader";
import RayaField from "../../elements/fields/RayaField";
import {theme} from "../../../../config/design/theme";
import {Locate, MapPin} from "lucide-react";
import clsx from "clsx";
import {useTranslation} from "react-i18next";
import Button from "@mui/material/Button";
import LocateMeButton from "./LocateMeButton";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../config/design/styles";
import {connect} from "trim-redux";
import LoginDialog from "../../../pages/front/components/LoginDialog";

const MapAddressChooserField = (props) => {
    const { t } = useTranslation();

    const [address, setAddress] = useState("");
    const [location, setLocation] = useState({});
    const [predictions, setPredictions] = useState([]);
    const [isFocused, setIsFocused] = useState(false);
    const [authOpen, setAuthOpen] = useState(false);

    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    useEffect(() => {
        props.setLocation(location)
        setAddress(location.address);
    }, [location]);
    useEffect(() => {
        if(!!props.location?.address){
            setAddress(props.location.address);
        }
    }, [props.location]);
    const handleInputChange = async (event) => {
        if(props.isAuth){
            const value = event.target.value;
            setAddress(value);

            if (value.trim() === "") {
                setPredictions([]);
                return;
            }

            const loader = new Loader({
                apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
                libraries: ["places"],
            });

            loader.load().then(() => {
                const service = new window.google.maps.places.AutocompleteService();
                service.getPlacePredictions({ input: value }, (results) => {
                    setPredictions(results || []);
                });
            });
        }else{
            setAuthOpen(true)
        }

    };

    const handlePredictionSelect = async (prediction) => {
        const loader = new Loader({
            apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
            libraries: ["places"],
        });

        loader.load().then(() => {
            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({ placeId: prediction.place_id }, (results, status) => {
                if (status === "OK" && results[0]) {
                    const location = results[0].geometry.location;
                    const components = results[0].address_components;

                    // Extract province, country, and coordinates
                    const fullAddress = results[0].formatted_address;
                    const province = getAddressComponent(components, "administrative_area_level_1");
                    const country = getAddressComponent(components, "country");
                    const coordinates = {
                        lat: location.lat(),
                        lng: location.lng(),
                    };
                    setLocation({
                        address : fullAddress,
                        province,
                        country,
                        coordinates,
                    })
                    setPredictions([]);
                    setIsFocused(false);
                }
            });
        });
    };

    const getAddressComponent = (components, type) => {
        const component = components.find((c) => c.types.includes(type));
        return component ? component.long_name : "";
    };
    const handleClickField = () => {
        if(!props.isAuth){
            setAuthOpen(true)
        }
    }
    return (
        <>
            <FormControl fullWidth variant="outlined" sx={{ position: "relative" }}>
                <RayaField
                    placeholder={t(isMobile ? 'selectAddress'  : 'selectYourAddress')}
                    slotProps={{
                        input:{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <MapPin className="lucide-icon-primary"/>
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment position="end">
                                    <LocateMeButton setLocation={(res) => setLocation(res)}/>
                                </InputAdornment>
                            ),
                        }
                    }}
                    className={clsx("pink-field",props.clName)}
                    value={address}
                    onChange={handleInputChange}
                    onClick={() => handleClickField()}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setTimeout(() => setIsFocused(false), 100)}
                    fullWidth
                    autoComplete="off"
                />
                {isFocused && predictions.length > 0 && (
                    <Box
                        sx={{
                            position: "absolute",
                            top: "100%",
                            left: 0,
                            right: 0,
                            zIndex: 10,
                            backgroundColor: "white",
                            boxShadow: 2,
                            borderRadius: 4,
                            padding:1,
                            mt: 1,
                            maxHeight: 200,
                            overflowY: "auto",
                        }}
                    >
                        {predictions.map((prediction) => (
                            <MenuItem
                                key={prediction.place_id}
                                onClick={() => handlePredictionSelect(prediction)}
                                sx={{ "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.08)" } }}
                            >
                                {prediction.description}
                            </MenuItem>
                        ))}
                    </Box>
                )}
            </FormControl>
            <LoginDialog open={authOpen} setOpen={setAuthOpen} />
        </>

    );
};
const mstp = state => ({
    navCollapsed: state.navCollapsed,
    logo: state.logo,
    user: state.user,
    isAuth: state.isAuth,
});
export default withStyles(Styles)(connect(mstp)(MapAddressChooserField));
